module.exports = __webpack_public_path__ + "static/img/微信二维码.2aed5eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/微信二维码.jpg
// module id = uLKI
// module chunks = 1